import { apiDate, uuid, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { ApiUserSchema } from './ApiUserSchema';

// *******************************************************************
// UserToScan API
// *******************************************************************
export const ApiUserToScanSchema = zodLess({
  userId: uuid,
  scanId: uuid,
  createdAt: apiDate,
  updatedAt: apiDate,
});
export type ApiUserToScan = ZodLessInfer<typeof ApiUserToScanSchema>;

export const ApiUserToScanWithUserSchema = ApiUserToScanSchema.extend({
  user: ApiUserSchema,
});
export type ApiUserToScanWithUser = ZodLessInfer<typeof ApiUserToScanWithUserSchema>;
